export type DocumentKind = 'image' | 'pdf' | 'docx' | 'other'

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg', 'avif', 'bmp']

const extensionOf = (name: string) => (name.split(/[?#]/)[0]!.split('.').pop() ?? '').toLowerCase()

/** The first bytes of a file, as text: a PDF starts with `%PDF-`, and a Word document (a zip) with `PK`. */
async function magicOf(blob: Blob): Promise<string> {
  const head = new Uint8Array(await blob.slice(0, 5).arrayBuffer())
  return String.fromCharCode(...head)
}

/**
 * What kind of file it is. The server hands every file over as an anonymous download, so the name says most of it, and the first bytes settle
 * what the name cannot: a PDF is recognised by `%PDF-` even when it is named like a picture, and a `.docx` must really be a zip. Anything else
 * that is (or is named like) a picture is a picture.
 */
export async function detectDocumentKind(name: string, blob: Blob): Promise<DocumentKind> {
  const extension = extensionOf(name)
  const magic = await magicOf(blob)
  if (magic.startsWith('%PDF-')) return 'pdf'
  if (extension === 'docx' && magic.startsWith('PK')) return 'docx'
  if (blob.type.startsWith('image/') || IMAGE_EXTENSIONS.includes(extension)) return 'image'
  return 'other'
}
